module.exports = __webpack_public_path__ + "static/media/rajvee.0a31cdbf.jpeg";